import React, { useEffect } from 'react';
import ProductSelectorAutocomplete from '../products/productselectorautocomplete';
import {
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    ToggleButton,
    ToggleButtonGroup,
    useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import NewProductRequiredView from '../products/newproductrequiredview';
import { useTranslation } from 'react-i18next';
import SurveyFilterInfo from './surveyfilterinfo';

const closeButtonStyle = {
    position: 'absolute',
    right: 1,
    top: 1,
    color: 'grey.500',
};

function MyDialogTitle({ onClose, title }) {
    return (
        <DialogTitle id="simple-dialog-title">
            {title}
            <IconButton aria-label="close" sx={closeButtonStyle} onClick={onClose}>
                <CloseIcon />
            </IconButton>
        </DialogTitle>
    );
}

export default function FilterProductSelectDialog(props) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [title, setTitle] = React.useState(!!props.title ? props.title : 'Valitse uusi suodatin');
    const [showNewProdEdit, setShowNewProdEdit] = React.useState(false);
    const { t } = useTranslation();
    const filterInfos = props.filterInfos || [];
    let initialToggles = filterInfos.length > 0 ? ['tuotteet'] : ['tuotteet', 'sarjat'];
    const [toggles, setToggles] = React.useState(initialToggles);

    useEffect(() => {
        setTitle(props.title);
    }, [props.show, props.title]);

    const handleClose = () => {
        props.selected(null);
    };

    const newProduct = () => {
        setShowNewProdEdit(true);
        setTitle(t('product.newProduct'));
    };

    const cancel = () => {
        setShowNewProdEdit(false);
        setTitle(t('product.selectNewProduct'));
    };

    const toggle = (event, newToggles) => {
        setToggles(newToggles);
    };

    return (
        <Dialog
            onClose={handleClose}
            aria-labelledby="simple-dialog-title"
            open={props.show}
            fullWidth={true}
            maxWidth={'md'}
            fullScreen={fullScreen}>
            <MyDialogTitle onClose={handleClose} title={title} />
            <DialogContent>
                <ToggleButtonGroup value={toggles} onChange={toggle} aria-label="text formatting">
                    <ToggleButton value="tuotteet" aria-label="products">
                        Tuotteet
                    </ToggleButton>
                    {filterInfos && filterInfos.length > 0 && (
                        <ToggleButton value="show-all-products" aria-label="show all products">
                            Näytä kaikki tuotteet
                        </ToggleButton>
                    )}
                    <ToggleButton value="sarjat" aria-label="bundles">
                        Sarjat
                    </ToggleButton>
                </ToggleButtonGroup>
                {!showNewProdEdit && filterInfos && filterInfos.length > 0 && (
                    <div style={{ display: 'inline-block' }}>
                        <SurveyFilterInfo filterInfo={filterInfos[0]} id={'filterInfo'} compact={true} />
                    </div>
                )}
                {!showNewProdEdit && (
                    <ProductSelectorAutocomplete
                        filterInfos={filterInfos}
                        showAllProducts={toggles.includes('show-all-products')}
                        dismiss={handleClose}
                        selected={props.selected}
                        allowNewProd={props.allowNewProd}
                        newProduct={newProduct}
                        showBundles={props.showBundles && toggles.includes('sarjat')}
                        hideProducts={!toggles.includes('tuotteet')}
                    />
                )}
                {showNewProdEdit && (
                    <NewProductRequiredView
                        selected={props.selected}
                        cancel={cancel}
                        productRequestHint={props.productRequestHint}
                        showBundles={props.showBundles && toggles.includes('sarjat')}
                        hideProducts={!toggles.includes('tuotteet')}
                    />
                )}
            </DialogContent>
        </Dialog>
    );
}
